import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { AuthorCard, User } from "../../../User";
export const PopularCreatorList = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ _jsx("ul", {
        className: "w-full gap-[20px] grid grid-cols-[minmax(min-content,_1fr)_minmax(min-content,_1fr)_minmax(min-content,_1fr)] overflow-x-auto pb-4 md:gap-8 lg:gap-12 lg:pb-8 lg:overflow-x-visible",
        children: data.map((user)=>/*#__PURE__*/ _jsx("li", {
                className: "w-full",
                children: /*#__PURE__*/ _jsx(AuthorCard, {
                    data: User.fromExtendedAccountDto(user)
                })
            }, user.cognito_id))
    });
};
